
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { addVariousTags, deleteVariousTags, getVariousTagsList, modifyVariousTags } from '@/api/allTags';

@Component({
  name: 'SettingTemplateImage',
  components: {

  }
})
export default class extends Vue {
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  private tableData = []
  private addImageVisible = false
  private listLoading = false;
  private formAdd:any = {
    id: '',
    name: ''
  }

  created() {
    this.pagination.currentPage = 1;
    this.getVariousTagsList();
  }

  private getVariousTagsList() {
    let VariousTagsParam: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      type: 3
    };
    getVariousTagsList(VariousTagsParam).then(res => {
      if (res.data) {
        this.tableData = res.data.list;
        this.pagination.total = parseInt(res.data.count);
      } else {
        this.tableData = [];
      }
    }).catch((err: any) => {
      let msg = err.msg;
      this.pagination.total = 0;
      this.pagination.currentPage = 1;
    });
  }

  private editHandle(val:any) {
    this.addImageVisible = true;
    this.formAdd = {
      id: val.id,
      name: val.name
    };
  }
  private handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getVariousTagsList();
  }
  private handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getVariousTagsList();
  }
  private AddHandle() {
    this.addImageVisible = true;
    this.formAdd = {
      id: '',
      name: ''
    };
  }

  private SaveReasonHandle() {
    if (!this.formAdd.name || this.formAdd.name.length > 20) {
      this.showErrorMsg('请输入图片分类,限20字');
      return;
    }
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      name: this.formAdd.name,
      type: 3
    };
    if (!this.formAdd.id) {
      addVariousTags(params)
        .then((res:any) => {
          this.addImageVisible = false;
          this.pagination.currentPage = 1;
          this.getVariousTagsList();
          this.showSuccessMsg(res.msg);
        })
        .catch((err) => {
          let msg = err.msg;
          this.showErrorMsg(msg);
        });
    } else {
      params.tags_id = this.formAdd.id;
      modifyVariousTags(params)
        .then((res:any) => {
          this.addImageVisible = false;
          this.pagination.currentPage = 1;
          this.getVariousTagsList();
          this.showSuccessMsg(res.msg);
        })
        .catch((err) => {
          let msg = err.msg;
          this.showErrorMsg(msg);
        });
    }
  }

  private deleteHandle(val:any) {
    this.$confirm('确定删除这条数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          tags_id: val.id,
          type: 3
        };
        deleteVariousTags(params)
          .then((res:any) => {
            this.pagination.currentPage = 1;
            this.getVariousTagsList();
            this.showSuccessMsg(res.msg);
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {
      });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
